import {isCloud} from '../../../../utils/featureToggles'
import {resolveHelpURL} from '../../../../utils/url'

const WHATS_NEW_CLOUD_HREF =
  'https://www.jetbrains.com/help/teamcity/cloud/what-s-new-in-teamcity-cloud.html'
export const whatsNewHref: string = isCloud
  ? WHATS_NEW_CLOUD_HREF
  : resolveHelpURL('what-s-new-in-teamcity.html')
export const aboutSakuraUIHref: string = resolveHelpURL('teamcity-sakura-ui.html')
export const feedbackHref: string = resolveHelpURL('troubleshooting.html')
